'use strict';

import getCookie from 'utils/getCookie';


const SELECTORS = {
    name: '.js-account-name',
    html: 'html',
};

(function () {
    let accountName = getCookie('bo_first_name');
    let accountNameSelector = document.querySelector(SELECTORS.name);
    let guestUser = !!getCookie('is_guest_login');

    if (!guestUser && getCookie('_bo_logged_in')) {
        document.querySelector(SELECTORS.html).classList.add('js-user-status--logged-in')
    }
    if (accountName && accountNameSelector) {
        accountNameSelector.innerText = 'Hi ' + accountName;
    }
}());
